import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import AchievementService from './AchievementService';

import schema from './jsonSchema';
const jsonSchema = schema;
const mergedJsonSchema = (jsonSchema, manualAchievements) => {
  return jsonSchema.map(field => {
    if (field.type === 'group') {
      return {
        ...field,
        fields: field.fields.map(f => assignValueToJsonSchema(f))
      };
    } else {
      return assignValueToJsonSchema(field, manualAchievements);
    }
  });
};

const assignValueToJsonSchema = (field, manualAchievements) => {
  console.log(manualAchievements);
  if (field.name === 'achievement') {
    return {
      ...field,
      options: manualAchievements
    };
  }
  return field;
};
const AddAchievementForm = ({refreshCard}) => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [manualAchievements, setManualAchievements] = useState();
  useEffect(() => {
    AchievementService.retrieveAllAchievementByAccount().then(data => {
      console.log('All Achievements', data);
      const manualAchievements = data
        .filter(a => a.manual)
        .map(a => ({ label: a.name, value: a.identifier }));
      console.log('Manual Achivements', manualAchievements);
      setManualAchievements(manualAchievements);
      setShowForm(true);
    });
    if (undefined !== identifier) {
      AchievementService.retrieveAddAchievement(identifier)
        .then(data => {
          setData(data);
        })
        .catch(error => console.log(error));
    }
  }, [identifier]);
  const handleAddAchievementFormSubmit = formData => {
    AchievementService.saveAthleteAchievement(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
        refreshCard(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Achievement',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save AddAchievement');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Create AddAchievement',
    ' ',
    buttonsConf
  );

  return (
    <>
      {modalShow && (
        <FormModal
          message={'Achievement  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow} 
          redirectUrl='/app/wod/dashboard'
        />
      )}
      <Card>
        <Card.Body>
          {showForm && (data || undefined === identifier) ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleAddAchievementFormSubmit}
              manualAchievements={manualAchievements}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({
  data,
  buttonsConf,
  onSubmit,
  manualAchievements
}) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    mergedJsonSchema(jsonSchema, manualAchievements),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default AddAchievementForm;
